import { put, delay, takeLatest, call, all, select } from 'redux-saga/effects';
import {
  GET_USER_FITBIT_LOGS_BY_ID,
  GET_USER_NUTRITION_BY_ID,
  GET_USER_NUTRITION_PREFERENCE_BY_ID,
  UPDATE_CLIENT_NUTRITION_PREFERENCES,
  DELETE_MEALPLAN_TEMPLATE,
  UPDATE_MEALPLAN_BY_ID,
  GET_MEALPLAN_BY_ID,
  GET_COACH_MEALPLANS,
  GET_USER_MEALPLAN_BY_ID,
  GET_CLIENT_PROFILE_BY_ID,
  UPDATE_CLIENT_MACROS,
  SAVE_CLIENT_NUTRITION,
  DELETE_CUSTOM_MEAL_PLAN,
  GET_CLIENT_SUGGESTIONS,
  // ADD_CLIENT_WEIGHT_TO_PROFILE
} from './constants';
import {
  getUserFitbitLogsByIdSuccess,
  getUserFitbitLogsByIdError,
  getUserNutritionByIdSuccess,
  getUserNutritionByIdError,
  getUserNutritionPreferenceByIdSuccess,
  getUserNutritionPreferenceByIdError,
  updateClientNutritionPreferencesSuccess,
  updateClientNutritionPreferencesError,
  deleteMealPlanTemplateSuccess,
  updateMealplanByIdSuccess,
  getMealplanByIdSuccess,
  getCoachMealPlansSuccess,
  getUserMealPlanByIdSuccess,
  getUserMealPlanByIdError,
  getClientProfileByIdSuccess,
  getClientProfileByIdError,
  updateClientMacrosSuccess,
  updateClientMacrosError,
  saveClientNutritionSuccess,
  saveClientNutritionError,
  deleteCustomMealPlanSuccess,
  getClientSuggestionsSuccess,
  getClientSuggestionsError,
  // addClientWeightToProfileSuccess,
  // addClientWeightToProfileError
} from './actions';
import { fetchData, postData } from '../api';
import moment from 'moment';
import { toast } from '../../components/Toast';

export function* getUserFitbitLogsById({ userId }) {
  try {
    const token = window.localStorage.token;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId: userId }),
    };
    let url = `${process.env.REACT_APP_API_URL}/auth/fitbit/food-logs/${userId}`;
    let payload = yield call(fetchData, url, config);
    yield put(getUserFitbitLogsByIdSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
    console.log(err);
    yield put(getUserFitbitLogsByIdError(error));
  }
}

export function* getUserNutritionById({ userId }) {
  try {
    const token = window.localStorage.token;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId: userId }),
    };
    let url = `${process.env.REACT_APP_API_URL}/api/nutrition/user/${userId}`;
    let payload = yield call(fetchData, url, config);
    yield put(getUserNutritionByIdSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
    yield put(getUserNutritionByIdError(error));
  }
}

export function* getUserNutritionPreferencesById({ userId }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/nutrition-preference/user/${userId}`;
    const token = window.localStorage.token;
    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    let nutritionPreferences = yield call(fetchData, url, config);
    yield put(getUserNutritionPreferenceByIdSuccess(nutritionPreferences));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(getUserNutritionPreferenceByIdError(error));
  }
}

// Trainer-write saga. POSTs the restrictions array to
// /api/nutrition-preference/user/:clientId — the server upserts the
// NutritionPreferences doc keyed to the CLIENT, not the requesting
// trainer. Error handler treats `err.json` defensively because the
// underlying `fetchData` helper raises both `Response`-shaped objects
// (parsed-fail) and plain Error objects (network), and the latter
// have no `.json()`.
export function* updateClientNutritionPreferences({ userId, restrictionsArr }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/nutrition-preference/user/${userId}`;
    const token = window.localStorage.token;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(restrictionsArr),
    };
    const updated = yield call(fetchData, url, config);
    yield put(updateClientNutritionPreferencesSuccess(updated));
  } catch (err) {
    console.log(err);
    const error =
      err && typeof err.json === 'function'
        ? yield err.json()
        : err?.message || 'Failed to update preferences';
    yield put(updateClientNutritionPreferencesError(error));
  }
}

export function* deleteMealPlanTemplate({ id }) {
  try {
    const token = window.localStorage.token;
    const config = {
      method: 'DELETE',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const url = `${process.env.REACT_APP_API_URL}/api/mealplan/template/${id}`;
    yield call(fetchData, url, config);
    yield put(deleteMealPlanTemplateSuccess(id));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
  }
}

export function* updateMealplanById({ id, plan }) {
  try {
    const token = window.localStorage.token;
    const config = {
      method: 'PUT',
      body: JSON.stringify({ ...plan }),
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const url = `${process.env.REACT_APP_API_URL}/api/mealplan/template/${id}`;
    const payload = yield call(fetchData, url, config);
    yield put(updateMealplanByIdSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
  }
}

export function* getMealplanById({ id }) {
  try {
    let payload;
    if (id === 'new') {
      const getFormattedPlan = function (s, e) {
        for (var a = {}, d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
          a[moment(d).format('YYYY-MM-DD')] = [];
        }
        return a;
      };
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      const { startDate, endDate, preference } = params;
      payload = {
        plan: {
          mealplan: getFormattedPlan(new Date(startDate), new Date(endDate)),
          preference,
          target: {
            calories: 0,
            carb: 0,
            fats: 0,
            protein: 0,
          },
        },
      };
      yield delay(1);
    } else {
      const token = window.localStorage.token;
      const config = {
        method: 'GET',
        headers: {
          'x-auth-token': token,
          'Content-Type': 'application/json',
        },
      };
      const url = `${process.env.REACT_APP_API_URL}/api/mealplan/template/${id}`;
      payload = yield call(fetchData, url, config);
    }
    yield put(getMealplanByIdSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
  }
}

export function* getCoachMealPlans() {
  try {
    const token = window.localStorage.token;
    const config = {
      method: 'GET',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    // Always fetch both drafts + published so the library's
    // All / Published / Drafts segmented pill can switch client-
    // side without re-fetching. Matches the workout library's
    // pre-fetched filter convention.
    const url = `${process.env.REACT_APP_API_URL}/api/mealplan/myTemplates?draft=all`;
    const payload = yield call(fetchData, url, config);
    yield put(getCoachMealPlansSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
  }
}

export function* getUserMealPlanById({ userId }) {
  try {
    const token = window.localStorage.token;
    const config = {
      method: 'GET',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const url = `${process.env.REACT_APP_API_URL}/api/profile/user/${userId}`;
    const payload = yield call(fetchData, url, config);
    yield put(getUserMealPlanByIdSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
    yield put(getUserMealPlanByIdError(error));
  }
}

export function* getClientProfileById({ userId }) {
  try {
    const token = window.localStorage.token;
    const config = {
      method: 'GET',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const url = `${process.env.REACT_APP_API_URL}/api/profile/user/${userId}`;
    const payload = yield call(fetchData, url, config);
    yield put(getClientProfileByIdSuccess(payload));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
    yield put(getClientProfileByIdError(error));
  }
}

const showToasterForProfileUpdate = (msg) => {
  toast.success(msg ? msg : '🎉 Your assessment data have been updated!', {
    position: 'top-right',
    duration: 5000,
  });
};

export function* updateClientMacros(payload) {
  const token = localStorage.token;
  const body = payload.clientProfile;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/profile`;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    };
    const payload = yield call(fetchData, url, config);
    yield put(updateClientMacrosSuccess(payload));
    const nutrition = yield select((state) => state.admin.nutrition);
    yield all([
      call(saveClientNutrition, nutrition),
      // call(addClientWeightToProfile, body),
    ]);
    showToasterForProfileUpdate('🎉 Macronutrients data have been updated!');
  } catch (err) {
    const error = yield err.json();
    console.log(error);
    yield put(updateClientMacrosError(error));
  }
}

export function* saveClientNutrition(action) {
  const token = localStorage.token;
  try {
    // Called two ways: dispatched via takeLatest (action shape is
    // `{ type, nutrition: { nutritionResults } }`) OR invoked directly
    // with `yield call(saveClientNutrition, nutrition)` from
    // updateClientMacros (arg shape is `{ nutritionResults }`).
    // Resolve the payload from whichever path carries it.
    const nutritionResults =
      action?.nutrition?.nutritionResults ?? action?.nutritionResults;
    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const userId = yield select((state) => state.admin.clientProfile.user._id);
    const url = `${process.env.REACT_APP_API_URL}/api/nutrition/${userId}`;
    yield call(() => postData(url, config, nutritionResults));
    yield put(saveClientNutritionSuccess(nutritionResults));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
    yield put(saveClientNutritionError(error));
  }
}

export function* deleteCustomMealPlan({ mealPlanId }) {
  try {
    const token = window.localStorage.token;
    const config = {
      method: 'DELETE',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const url = `${process.env.REACT_APP_API_URL}/api/profile/delete-meal-plan/${mealPlanId}`;
    yield call(fetchData, url, config);
    yield put(deleteCustomMealPlanSuccess(mealPlanId));
  } catch (err) {
    const error = yield err.json();
    console.log(error);
  }
}

// export function* addClientWeightToProfile(clientProfile) {
//   let weightKg = clientProfile.isMetric ? clientProfile.currentWeight : Number(poundsToKgs(clientProfile.currentWeight));
//   let weightLb = !clientProfile.isMetric ? clientProfile.currentWeight : Number(kgsToPounds(clientProfile.currentWeight));
//   let weight = { weightKg: weightKg, weightLb: weightLb };
//   if (!clientProfile.weight.length || ((+weightKg !== clientProfile.weight[0].weightKg) && (weightLb !== clientProfile.weight[0].weightLb))) {
//     const token = localStorage.token;
//     try {
//       const url = `${process.env.REACT_APP_API_URL}/api/profile/weight`;
//       const config = {
//         method: "PUT",
//         headers: {
//           "x-auth-token": token,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(weight)
//       }
//       const payload = yield call(fetchData, url, config);
//       yield put(addClientWeightToProfileSuccess(payload));

//     } catch (err) {
//        const error = yield err.json();
//        console.log(error);
//        yield put(addClientWeightToProfileError(error));
//     }
//   }
// }

export function* getClientSuggestions({ clientId, limit }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/admin/suggestions/${clientId}?limit=${limit || 3}`;
    const config = {
      headers: {
        'x-auth-token': window.localStorage.token,
        'Content-Type': 'application/json',
      },
    };
    const suggestions = yield call(fetchData, url, config);
    yield put(getClientSuggestionsSuccess(suggestions));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response — fall through with the original.
    }
    console.log('getClientSuggestions failed:', error);
    yield put(getClientSuggestionsError(error));
  }
}

export default function* adminSaga() {
  yield takeLatest(GET_USER_FITBIT_LOGS_BY_ID, getUserFitbitLogsById);
  yield takeLatest(GET_USER_NUTRITION_BY_ID, getUserNutritionById);
  yield takeLatest(
    GET_USER_NUTRITION_PREFERENCE_BY_ID,
    getUserNutritionPreferencesById
  );
  yield takeLatest(
    UPDATE_CLIENT_NUTRITION_PREFERENCES,
    updateClientNutritionPreferences
  );
  yield takeLatest(DELETE_MEALPLAN_TEMPLATE, deleteMealPlanTemplate);
  yield takeLatest(UPDATE_MEALPLAN_BY_ID, updateMealplanById);
  yield takeLatest(GET_MEALPLAN_BY_ID, getMealplanById);
  yield takeLatest(GET_COACH_MEALPLANS, getCoachMealPlans);
  yield takeLatest(GET_USER_MEALPLAN_BY_ID, getUserMealPlanById);
  yield takeLatest(GET_CLIENT_PROFILE_BY_ID, getClientProfileById);
  yield takeLatest(UPDATE_CLIENT_MACROS, updateClientMacros);
  yield takeLatest(SAVE_CLIENT_NUTRITION, saveClientNutrition);
  yield takeLatest(DELETE_CUSTOM_MEAL_PLAN, deleteCustomMealPlan);
  yield takeLatest(GET_CLIENT_SUGGESTIONS, getClientSuggestions);
  // yield takeLatest(ADD_CLIENT_WEIGHT_TO_PROFILE, addClientWeightToProfile);
}
